export default {"src":"/_next/static/media/norway.2659a2a0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};